import { IAttachmentReferenceRequest } from 'utils/attachments';

const ExerciseCategoryName = {
  THEORY: 'Theory',
  PRACTICE: 'Practice',
};

const ExerciseCategoryId = {
  THEORY: 1,
  PRACTICE: 2,
};

type IExerciseCategoryName =
  | typeof ExerciseCategoryName.THEORY
  | typeof ExerciseCategoryName.PRACTICE;

type IExerciseCategoryId =
  | typeof ExerciseCategoryId.THEORY
  | typeof ExerciseCategoryId.PRACTICE;

interface IExerciseCategory {
  id: IExerciseCategoryId;
  name: IExerciseCategoryName;
}

type IExerciseCategoryNames = [
  typeof ExerciseCategoryName.THEORY,
  typeof ExerciseCategoryName.PRACTICE,
];

interface IExerciseAttachment {
  id: number;
  fileName: string;
  contentType: string;
  sizeBytes: number;
  created: string;
}

interface IExercise {
  id: number;
  name: string;
  description: string;
  exCategory: IExerciseCategory;
  isCompleted?: boolean;
  attachments?: IExerciseAttachment[];
}

type IExerciseRequest = Omit<IExercise, 'exCategory' | 'id' | 'attachments'> & {
  categoryId: typeof ExerciseCategoryId.THEORY | typeof ExerciseCategoryId.PRACTICE;
  levelId: number;
  attachments?: IAttachmentReferenceRequest[];
  // Update-only: ids of existing attachments to keep. Every existing
  // attachment not listed here is permanently deleted once the update
  // succeeds. Omit entirely on create, or on update when attachments aren't
  // being touched.
  retainedAttachmentIds?: number[];
};

export type {
  IExercise,
  IExerciseAttachment,
  IExerciseCategory,
  IExerciseCategoryNames,
  IExerciseRequest,
  IExerciseCategoryName,
};
export { ExerciseCategoryId, ExerciseCategoryName };
export type { IExerciseCategoryId };
